import { useState } from 'react';
import { GradingCategoryClient, GradingCategoryDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useGradingCategoryApi = () => {
    const apiClient = new GradingCategoryClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: GradingCategoryDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createGradingCategory(data);
        } catch (err: any) {
            setError(err.message || 'Error creating GradingCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: GradingCategoryDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateGradingCategory(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating GradingCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getGradingCategoryById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching GradingCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchGradingCategories(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching GradingCategories');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteGradingCategory(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting GradingCategory');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};